import { Controller } from "@hotwired/stimulus"
import ApexCharts from "apexcharts"

export default class extends Controller {
  static targets = ["chart"]
  static values = {
    url: String,
    height: { type: String, default: "100%" },
    width: { type: String, default: "100%" },
    minRadius: { type: Number, default: 40 },
    xMin: { type: Number, default: 0 },
    xMax: { type: Number, default: 15 },
    yMin: { type: Number, default: 0 },
    yMax: { type: Number, default: 15 }
  }

  connect() {
    this.loadChartData()
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy()
    }
  }

  async loadChartData() {
    if (!this.hasUrlValue) return

    this.element.classList.add("loading")
    try {
      const response = await fetch(this.urlValue)
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`)

      const data = await response.json()
      this.renderChart(data)
    } catch (error) {
      console.error("Error loading chart data:", error)
    } finally {
      this.element.classList.remove("loading")
    }
  }

  updateUrl(event) {
    event.preventDefault()
    const url = event.currentTarget.dataset.url
    if (url) {
      this.urlValue = url

      // Update active state for period buttons
      const buttons = document.querySelectorAll('[data-action="click->bubble-chart#updateUrl"]')
      buttons.forEach(button => {
        button.classList.remove('bg-blue-100', 'text-blue-700')
        button.classList.add('bg-gray-100', 'text-gray-700')
      })

      event.currentTarget.classList.remove('bg-gray-100', 'text-gray-700')
      event.currentTarget.classList.add('bg-blue-100', 'text-blue-700')

      // Reload chart data
      if (this.chart) {
        this.chart.destroy()
      }
      this.loadChartData()
    }
  }

  renderChart(data) {
    const options = {
      chart: {
        height: this.heightValue,
        width: this.widthValue,
        type: 'bubble',
        toolbar: {
          show: false
        },
        zoom: {
          enabled: false
        }
      },
      series: data.series,
      dataLabels: {
        style: {
          fontSize: '20px',
          fontFamily: 'Inter, ui-sans-serif',
          fontWeight: '400',
          colors: ['#fff', '#1f2937', '#fff']
        },
        formatter: (value) => value ? `${value}%` : ''
      },
      fill: {
        opacity: 1
      },
      legend: {
        show: false
      },
      stroke: {
        width: 5,
        colors: ['rgb(255, 255, 255)']
      },
      plotOptions: {
        bubble: {
          zScaling: false,
          minBubbleRadius: this.minRadiusValue
        }
      },
      grid: {
        show: false,
        padding: {
          top: 0,
          bottom: 0,
          left: 0,
          right: 0
        }
      },
      xaxis: {
        min: this.xMinValue,
        max: this.xMaxValue,
        labels: {
          show: false
        },
        axisBorder: {
          show: false
        },
        axisTicks: {
          show: false
        }
      },
      yaxis: {
        min: this.yMinValue,
        max: this.yMaxValue,
        labels: {
          show: false
        }
      },
      tooltip: {
        enabled: false
      },
      states: {
        hover: {
          filter: {
            type: 'none'
          }
        }
      },
      colors: data.colors || ['#22d3ee', '#e5e7eb', '#3b82f6']
    }

    this.chart = new ApexCharts(this.chartTarget, options)
    this.chart.render()
  }
} 